<template>
    <div class="vue-template">

        <div class="card">
          <div class="card-body">
              <h3 class="display-5">Attendance Ledger</h3>
              <br>
              <div class="text-left">
                <ul>
                  <li>Track team work hours</li><br>
                  <li>Security Features: Facial Recognition,<br>Location Tracking</li><br>
                  <li>Monthly Reports: Total working hours</li><br>
                </ul>
              </div>
              <div v-if="userLoggedIn==true" class="text-center">
                <button type="button" class="btn btn-dark" v-on:click.prevent="$router.push('/GetCheckin')">Begin</button>
              </div>
          </div>
          
        </div>

    </div>
</template>


<script>
import firebase from "firebase/app"
import 'firebase/auth'

export default {
  data() {
    return {
      userLoggedIn: false
    }
  },

  mounted: function(){
    this.checkLogIn()
  },

  methods: {
    checkLogIn () {
      var self = this
      console.log("checkLogIn")
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          self.userLoggedIn = true
        }
        else {
          self.userLoggedIn = false
        }
      })
    },
  }

}
</script>